import { AddressBookRow } from 'api/v1/addressBook'
import { Currency } from 'api/v1/market'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Ether } from 'types'
import { WithdrawLayoutType, WithdrawState, WithdrawStatus } from './types'

export function useWithdrawLayoutType() {
  return useSelector<RootState, WithdrawLayoutType>(
    (state) => state.withdraw.layoutType
  )
}
export function useTitleName() {
  return useSelector<RootState, string>((state) => state.withdraw.titleName)
}
export function useShowAddressBookList() {
  return useSelector<RootState, boolean>(
    (state) => state.withdraw.showAddressBookList
  )
}
export function useIsFocus() {
  return useSelector<RootState, boolean>((state) => state.withdraw.isFocus)
}
export function useShowAddAddress() {
  return useSelector<RootState, boolean>(
    (state) => state.withdraw.showAddAddress
  )
}
export function useIsUseAddressBook() {
  return useSelector<RootState, boolean>(
    (state) => state.withdraw.isUseAddressBook
  )
}
export function useAddOrEditAddress() {
  return useSelector<RootState, string>(
    (state) => state.withdraw.addOrEditAddress
  )
}
export function useAmount() {
  return useSelector<RootState, Ether>((state) => state.withdraw.amount)
}
export function useAddressBookList() {
  return useSelector<RootState, AddressBookRow[]>(
    (state) => state.withdraw.addressBookList
  )
}
export function useCurrentEditAddressBook() {
  return useSelector<RootState, AddressBookRow | undefined>(
    (state) => state.withdraw.currentEditAddressBook
  )
}
export function useCurrentUseAddressBook() {
  return useSelector<RootState, AddressBookRow | undefined>(
    (state) => state.withdraw.currentUseAddressBook
  )
}
export function useIsAddOrEditAddressBook() {
  return useSelector<RootState, number | undefined>(
    (state) => state.withdraw.isAddOrEditAddressBook
  )
}
export function useWithdrawAddress() {
  return useSelector<RootState, string>((state) => state.withdraw.address)
}
export function useSelectedToken() {
  return useSelector<RootState, Currency | undefined>(
    (state) => state.withdraw.selectedToken
  )
}
export function useSelectFast() {
  return useSelector<RootState, boolean>((state) => state.withdraw.selectFast)
}
export function useWithdrawStatus(txHash: string) {
  return useSelector<RootState, WithdrawStatus>(
    (state) => state.withdraw.withdrawStatus[txHash]
  )
}
export function useWithdrawing() {
  return useSelector<RootState, boolean>((state) => state.withdraw.withdrawing)
}
export function useWithdrawLimit() {
  return useSelector<RootState, WithdrawState['withdrawLimit']>(
    (state) => state.withdraw.withdrawLimit
  )
}
